import { PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'
import { PersonalizationWidgetConfiguration, PersonalizationWidgetProvider } from '@vp/design-personalization-widget'

import { PersonalizationWidgetProviderWrapperProps } from '~/app/features/FragmentRoot/contexts/personalization/interface'
import { usePersonalizationConfig } from '~/app/features/Gallery/hooks/usePersonalizationConfig'
import { getGalleryIdSelector } from '~/app/store/config'
import { useAnalytics } from '~/app/features/Gallery/hooks/useAnalytics'
import { LOGGER_SERVICE_NAME } from '~/shared/constants'

export const PersonalizationWidgetProviderWrapper = ({ localizations, children }: PropsWithChildren<PersonalizationWidgetProviderWrapperProps>) => {
  const { imageCopyKey, templateFields } = usePersonalizationConfig()
  const galleryId = useSelector(getGalleryIdSelector).toString()
  const analytics = useAnalytics()

  const isPhoto = imageCopyKey === 'Photo'

  const personalizationWidgetConfig: PersonalizationWidgetConfiguration = {
    textConfig: {
      enabledTextFields: templateFields,
    },
    imageConfig: {
      maxImages: 10,
      classifyImagesAsPhotos: isPhoto,
    },
    createBrandIfNoneExists: !isPhoto,
    allowRestoreFromBrand: !isPhoto,
  }

  const trackingData = {
    ...analytics.getProductData(),
  }

  return (
    <PersonalizationWidgetProvider
      localizations={localizations}
      configuration={personalizationWidgetConfig}
      localStoragePageKey={galleryId}
      trackingData={trackingData}
      hostName={LOGGER_SERVICE_NAME}
    >
      {children}
    </PersonalizationWidgetProvider>
  )
}
